// extracted by mini-css-extract-plugin
module.exports = {"center":"page-title_center__CS5FF"};